 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vsf-category~vsf-home~vsf-my-account~vsf-product~vsf-search-panel~vsf-search-panel-desktop~vsf-searc~49c21426","1":"vendors~vue-carousel","2":"vendors~vsf-wp-posts-index~vsf-wp-posts-show~vsf-wp-press-index~vsf-wp-press-show","3":"login~vsf-checkout~vsf-layout-default","4":"vendors~vsf-checkout~vsf-microcart~vsf-product","5":"vsf-layout-default~vsf-layout-empty~vsf-layout-minimal","6":"vendors~bodybuilder~vsf-product","7":"vendors~vsf-product~vue-vimeo-player","8":"vsf-checkout~vsf-microcart","9":"vsf-wp-posts-show~vsf-wp-press-show","12":"SwipeActions","14":"bodybuilder","15":"dayjs-locales-de","16":"dayjs-locales-en","17":"dayjs-locales-nl","18":"dayjs-locales-pl","19":"dayjs-locales-sv","20":"login","23":"vendors~vsf-checkout","24":"vendors~vsf-graphql","25":"vendors~vsf-layout-default","26":"vsf-career","27":"vsf-category","28":"vsf-checkout","29":"vsf-cms","30":"vsf-error","31":"vsf-head-img-banners-de_main-image-json","32":"vsf-head-img-banners-de_promoted_offers-json","33":"vsf-head-img-banners-it_main-image-json","34":"vsf-head-img-banners-it_promoted_offers-json","35":"vsf-head-img-main-image-json","36":"vsf-head-img-promoted_offers-json","37":"vsf-head-img-slider-json","38":"vsf-home","39":"vsf-languages-modal","40":"vsf-layout-default","41":"vsf-layout-empty","42":"vsf-layout-minimal","43":"vsf-microcart","44":"vsf-my-account","45":"vsf-not-found","46":"vsf-order-confirmation","47":"vsf-placepozniej","48":"vsf-product","49":"vsf-product-gallery-carousel","50":"vsf-product-gallery-overlay","51":"vsf-reset-password","52":"vsf-search-adapter-api-search-query-searchAdapter","53":"vsf-search-adapter-api-searchAdapter","54":"vsf-search-adapter-graphql-searchAdapter","55":"vsf-search-panel","56":"vsf-search-panel-desktop","57":"vsf-search-panel-mobile","58":"vsf-selling","59":"vsf-sidebar-menu","60":"vsf-typ","61":"vsf-typ-sale","62":"vsf-wishlist","63":"vsf-wp-posts-index","64":"vsf-wp-posts-show","65":"vsf-wp-press-index","66":"vsf-wp-press-show"}[chunkId]||chunkId) + "." + {"0":"7dddb27256ad1ef45a7b","1":"1a67be24c760f2333cd5","2":"e458a9700a73ca7e044e","3":"97f4896667b54af18a4b","4":"b500a7c1289d85d624ca","5":"1a9cd17cf7ee43537027","6":"b0122a8ea3bccc66aa5b","7":"15e237241c2ca57dd4de","8":"e9e7902f0f56c4a0caa1","9":"8c413eca5a46e27ad27d","10":"c2e20cd03afdada448d0","11":"0d3fc0b7fe55473761c2","12":"cfb9ff911c278f12bff8","14":"1eec1f2c40061c2ebcaf","15":"20a59dfa5dacabe30878","16":"1df4f4e8caf67c523238","17":"5f0e5a57ad11cb241e9b","18":"20989d5644b13b415442","19":"f3a256b3f62a1be2e0d7","20":"174e680f1cfaeee978d6","23":"48f53b8e63f45a64930f","24":"0e40ffb3dfd7ab5391d8","25":"4f44e64e0fef716b0adf","26":"11d37aee1f761209ddce","27":"5bc52e410ad4b9ea305c","28":"7210ffde5c18c0e12dc7","29":"84233785799aeef9d367","30":"e0ac35cae389a65fd87e","31":"f6eb35c9d21109ce0938","32":"258f403dcfe226a6d66a","33":"c2cfe348235cfd6703a5","34":"3eadd5e5240ee25c70d5","35":"3121d44564f0c34d3704","36":"734f92476b11a3e749d9","37":"58fff76587db5443b0d7","38":"e7ab3d752ad7ee9c472a","39":"c9dfa5fb1a14fd3cf812","40":"bfa8e0bf1a6d58d10c12","41":"6db3bb230fb4edfadc38","42":"c1b61a32d6a9d92e7a6b","43":"aa0a79207e044f5b10fc","44":"223a26b9ff8169b72b08","45":"4c1af55d2266ed4c0a47","46":"fcb6d569426f0aa4a148","47":"becb67daf656992edcf9","48":"e9949e93909f47417099","49":"afb603733e8282e68e86","50":"bb59d3424cd3c2cfe73c","51":"d8e17206308c762ca3b7","52":"86c395505f15a8ff28d9","53":"f6cafb3af93e27878d58","54":"c3b26878a2198d3fcb1b","55":"a1c351fdcacf6a05b4b8","56":"43d09f907f2cc337a86d","57":"3ff742aff912f55f2dd5","58":"74cd4114f026cb253457","59":"b972b5d31e6b622b2bb4","60":"31ed00751cef637ab581","61":"6ce58c05cc3c962db4f0","62":"b971af01477cc9861437","63":"eb8ddbd4b43679bbd1d7","64":"e40316f06f43c1e01dbf","65":"df4e229e719e0adbe374","66":"0284da68005ca2e42e59","67":"1c36fd76327f9ec884e3","68":"e7bdfdf2731b305e5dcb","69":"7abd271afc5234c480ad","70":"9f1378c6c6c83949e21d","71":"726b98092a9d661307f6","72":"0b6c07499d93226946d9","73":"6964ed95877a40d19bac","74":"b33e74b4fe71e0e589e0","75":"5c7d8880251c9f8297ae","76":"ff2fdad5803f5cd7587e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"40": [
 				4,
 				8,
 				43,
 				0,
 				62,
 				59
 			],
 			"43": [
 				12
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
